	<div class="fluid-container">
		<div class="row g-4">
			
		<div class="col-md-12">
			<div class="bg-share p-3">
			<div class="section-header text-start mt-2 ms-2">Sent Announcements</div>
			 <ng-container *ngIf="isSentAnnouncement">
             <div class="app-spinner">
               <mat-spinner></mat-spinner>
             </div>
            </ng-container>

	     <ng-container *ngIf="!isSentAnnouncement && _studyMaterialData.length > 0">
			<div
			*ngFor="let studyMaterial of _studyMaterialData"
			class="announcement-post mb-3 card p-3 mt-3 bg-announcement">
			<div class="d-flex align-items-center mb-2 justify-content-between">
				<div class="d-flex align-items-center">
				<img
					src="assets/images/avatar.png"
					alt="profile"
					class="avatar me-2"/>
				<div class="text-start">
					<strong>{{ studyMaterial.teacher_name }}</strong>
					<div class="text-muted small">
					{{ convertToIST(studyMaterial.created_at) }}
					</div>
				</div>
				</div>
				<div class="text-end">
				<button [matMenuTriggerFor]="menu" class="plain-icon">
					<mat-icon>more_vert</mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					<button mat-menu-item (click)="openEditPopup(studyMaterial)">
					Edit
					</button>
					<button
					mat-menu-item
					(click)="openDeleteDialogBox(studyMaterial.id)">
					Delete
					</button>
				</mat-menu>
				</div>
			</div>
			<!-- edit -->
			<div
				*ngIf="currentPopup === studyMaterial.id"
				(click)="closePopup($event)">
				<div (click)="$event.stopPropagation()">
				<form [formGroup]="editAnnouncementForm">
					<textarea
					formControlName="content"
					class="form-control announcement-textarea"></textarea>
					<div class="text-end mb-2">
					<button
						type="button"
						class="btn-cancel py-2 me-2"
						(click)="closePopup()">
						Cancel
					</button>
					<button
						type="button"
						(click)="updateAnnouncement()"
						class="btn-add"
						[disabled]="editAnnouncementForm.invalid">
						Update
					</button>
					</div>
				</form>
				</div>
			</div>

			<div class="mb-2 fs-6" *ngIf="currentPopup !== studyMaterial.id">
				{{ studyMaterial.content }}
			</div>
			<div *ngIf="studyMaterial.materials.length > 0">
				<div *ngFor="let material of studyMaterial.materials" class="mb-2">
			<ng-container *ngIf="material.is_material_file" class="mb-2">
				<a *ngIf="material.original_file_s3_url"
				[href]="material.original_file_s3_url"
				target="_blank" class="pdf-bg mb-2"
				rel="noopener noreferrer">
				<i class="bi bi-file-earmark-pdf"></i>
				{{ material.material_name }}
				</a>
		
		<span *ngIf="!material.original_file_s3_url && material.extracted_file_s3_url"
            class="pdf-bg mb-2">
         <i class="bi bi-file-earmark-pdf"></i>
         {{ material.material_name }}
      </span>
			</ng-container>
			<div *ngIf="material.original_website_url" class="mb-2 me-4">
      <a [href]="material.original_website_url"
         target="_blank" class="pdf-bg"
         rel="noopener noreferrer">
         <i class="bi bi-link-45deg"></i>
         {{ material.original_website_url }}
      </a>
             </div>
			 
           </div>
			</div>
			</div>
		  </ng-container>
        <ng-container *ngIf="!isSentAnnouncement && _studyMaterialData.length === 0">
         <div class="text-center mt-3 text-muted fs-6"> No announcements available. </div>
       </ng-container>
			</div>
			
		</div>
	    </div>
	   </div>